<template>
    <div>
        <b-button class="m-1" v-b-modal.createTiposDeDocumentos variant="primary"> 
            Crear tipo <b-icon icon="paperclip" font-scale="1"></b-icon>
        </b-button>

        <!-- Modal tipo de usuario -->
        <b-modal id="createTiposDeDocumentos" title="Crear usuario" class="" size="md" centered scrollable
            header-bg-variant="dark" v-model="modalShowTypeDocument" hide-footer>

            <template #modal-header="{ close }">
                <!-- Emulate built in modal header close button action -->
                <b-button size="sm" variant="outline-warning" @click="close()">
                    Cerrar
                </b-button>

            </template>

            <!-- cuerpo del modal -->
            <TypeDocumentForm></TypeDocumentForm>

        </b-modal>
    </div>
</template>
<script>
import TypeDocumentForm from './SettingTypeDocument/Type-document-form.vue'

export default {
    name: 'SettingTypeDocument',

    data() {
        return {
            modalShowTypeDocument: false
        }
    },

    components:{
        TypeDocumentForm
    },

    methods: {
        openModalTypeDocument() {
            this.modalShowTypeDocument = true;
        },

        closeModalTypeDocument() {
            this.modalShowTypeDocument = false;
        }
    }

}
</script>
<style></style>